import AuthContext from "context/AuthContext";
import {useContext} from "react";
import FormContainer from "./waste/FormContainer";
import FormContainerBridge from "./bridge/FormContainerBridge";

const FormContainerManager = ({
                                  title,
                                  itemsShow,
                                  setItemsShow,
                                  item,
                                  setItem,
                                  add,
                                  paramsTypes,
                                  setShow,
                                  show,
                                  setPrev,
                                  setShowCanvasEdit,
                                  showCanvasEdit,
                                  buttons,
                                  btnDelete,
                                  setBtnDelete,
                                  setRefreshData,
                                  items
                              }) => {
    const {panel} = useContext(AuthContext);
    switch (panel.panel_type) {
        case "b":
            return <FormContainerBridge title={title} itemsShow={itemsShow} setItemsShow={setItemsShow}
                                        item={item}
                                        setItem={setItem}
                                        add={add}
                                        paramsTypes={paramsTypes}
                                        setShow={setShow}
                                        show={show}
                                        setPrev={setPrev}
                                        setShowCanvasEdit={setShowCanvasEdit}
                                        showCanvasEdit={showCanvasEdit}
                                        buttons={buttons}
                                        btnDelete={btnDelete}
                                        setBtnDelete={setBtnDelete}
                                        setRefreshData={setRefreshData}
                                        items={items}
            />;
        default:
            return <FormContainer title={title} itemsShow={itemsShow} setItemsShow={setItemsShow}
                                  item={item}
                                  setItem={setItem}
                                  add={add}
                                  paramsTypes={paramsTypes}
                                  setShow={setShow}
                                  show={show}
                                  setPrev={setPrev}
                                  setShowCanvasEdit={setShowCanvasEdit}
                                  showCanvasEdit={showCanvasEdit}
                                  buttons={buttons}
                                  btnDelete={btnDelete}
                                  setBtnDelete={setBtnDelete}
                                  setRefreshData={setRefreshData}
                                  items={items}
            />;
    }
    ;
}
export default FormContainerManager;